export const ADMINISTRATIVE_AREA_LEVEL_1_LABELS = {
    US: 'State',
    MX: 'State',
    AU: 'State/Territory',
    MY: 'State/Territory',
    CN: 'Province',
    CA: 'Province',
    IT: 'Province',
    ID: 'Province',
    DZ: 'Province',
    TH: 'Province',
    UZ: 'Province',
    EG: 'Governorate',
    AE: 'Emirate',
    BR: 'State'
};

export const DEAFULT_ADMINISTRATIVE_AREA_LEVEL_1_LABEL = 'Region';

export const AUTOCOMPLETE_COUNTRIES = [
    'US',
    'GB',
    'AU',
    'CA',
    'BR',
    'FR',
    'IN'
];

export const SAVED_CART_KEY = 'VOL_SAVED_CART';
export const SAVED_STORECREDIT_KEY = 'VOL_SAVED_STORECREDIT';



// WEBPACK FOOTER //
// ./src/app/constants.js